import { useContext } from 'react';

import { AuthContext, isAuthenticated } from '../contexts/authContext';

class NotAuthenticated extends Error {
  constructor(message = 'User is not signed in') {
    super(message);
  }
}

export function useCurrentUser() {
  const authContext = useContext(AuthContext);

  if (isAuthenticated(authContext)) {
    return authContext.authState.user;
  }

  return undefined;
}

/**
 * Gets the current user and throws unless they're signed in.
 * @throws {NotAuthenticated}
 */
export function useEnsureCurrentUser(errorMessage?: string) {
  const currentUser = useCurrentUser();

  if (!currentUser) {
    throw new NotAuthenticated(errorMessage);
  }

  return currentUser;
}
